import { useLocalSearchParams } from 'expo-router'

import { CommunitiesCategoryScreen } from '@/src/features/community/ui/screens/CommunitiesCategoryScreen'

export default () => {
  const { tag } = useLocalSearchParams<{ tag: string }>()
  return <CommunitiesCategoryScreen tag={tag} />
}
